<word>
    <div onclick={ props.btn_onclick } class="word { props.btn_class }">
        { props.word }
    </div>
</word>